import PropTypes from "prop-types"
import React from "react"

import ActivityEntryAuthor from "./ActivityEntryAuthor"

const ActivityEntry = ({ entry }) => (
  <article className="flex gap-3">
    <ActivityEntryAuthor author={entry.author} icon={entry.icon} />
    <div className="min-w-0 flex-1">
      <div className="text-xs">
        <span className="font-semibold">{entry.author.displayName}</span>
        <span className="text-gray-600" title={entry.createdAt.absolute}>
          {" · "}
          {entry.createdAt.relative}
        </span>
      </div>
      <div
        className="break-words text-xs text-gray-900"
        style={{ overflowWrap: "anywhere" }}
      >
        {entry.body}
      </div>
    </div>
  </article>
)

const entryShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["system", "note"]).isRequired,
  icon: PropTypes.string,
  author: PropTypes.shape({
    kind: PropTypes.oneOf(["system", "user"]).isRequired,
    displayName: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    backgroundColor: PropTypes.string,
  }).isRequired,
  body: PropTypes.string.isRequired,
  createdAt: PropTypes.shape({
    relative: PropTypes.string.isRequired,
    absolute: PropTypes.string.isRequired,
  }).isRequired,
})

ActivityEntry.propTypes = {
  entry: entryShape.isRequired,
}

ActivityEntry.entryShape = entryShape

export default ActivityEntry
